import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _LoanConfigProfile } from '../../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    disabled?: boolean;
}

export const SelectLoanConfigProfile = ({ idSelector, onChange, label, returnType = "ID", disabled }: Props) => {

    const { instance, setLista, lista } = useDataBean(_LoanConfigProfile);    
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDLoanConfigProfile === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDLoanConfigProfile,
                    label: `${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getLoanConfigProfileCatalog(null).then((resp: any) => {
            if (resp) setLista(resp);
        }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? null : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDLoanConfigProfile,
        label: `${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Perfil de Configuración"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una configuracion..."
                noOptionsMessage={() => "Sin coincidencias"}
                isDisabled={disabled}
            />
        </div >
    );
};
